<template>
  <v-dialog width="688" content-class="elevation-0" v-model="showDialog" persistent>
    <v-card width="688" height="777" class="sigfloCard elevation-0 pt-1" :loading="loading" :disabled="loading">
      <v-btn x-large icon color="black" class="closeButton" @click="$emit('close-dialog')"
        ><v-icon>mdi-close</v-icon></v-btn
      >
      <v-img width="64" height="64" :src="getIconImage(system.name)" class="systemIcon" />
      <div class="systemTitle sigfloH3 black--text">Add {{ system.name }} System</div>
      <div class="systemSubtitle sigfloBody400 textMuted">Choose a system type</div>
      <v-container class="overflow-y-auto subsystemCardContainer sigfloScrollbar">
        <v-card
          v-for="subsystemDefinition in configurator.availableSubsystemDefinitions"
          :key="subsystemDefinition.id"
          height="84"
          color="#F9F6FD"
          class="sigfloCard subsystemCard py-4 px-6 mb-4 elevation-0 sigfloNeutralBorder150"
          @click="createSubsystem(subsystemDefinition.id)"
        >
          <v-img width="40" height="40" :src="getIconImage(system.name)" class="subsystemIcon" />
          <div class="subsystemTitle sigfloBodyLarge textEmphasis">
            {{ subsystemDefinition.name }}
          </div>
          <div class="subsystemSubtitle sigfloBodySmall textMuted">
            {{ subsystemDefinition.description }}
          </div>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      system: {
        type: Object,
        required: true
      },
      showDialog: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        loading: false
      };
    },
    computed: {
      ...mapState(['configurator'])
    },
    methods: {
      /**
       * Creates a new subsystem with the specified subsystem ID.
       *
       * @param {string} subsystemId - The ID of the subsystem to create.
       * @returns {Promise} - A promise that resolves when the subsystem is created.
       */
      createSubsystem(subsystemId) {
        this.loading = true;
        this.$store
          .dispatch('configurator/createSubsystem', {
            systemId: this.system.id,
            subsystemDefinitionId: subsystemId
          })
          .then((createdSubsystem) => {
            this.loading = false;
            this.$store.commit('configurator/setCreateSubsystemDialog', false);
            this.openProject(
              this.configurator.currentProject.id,
              false,
              createdSubsystem.systemId,
              createdSubsystem.id
            );

            this.$emit('close-dialog');
          });
      }
    }
  };
</script>

<style scoped>
  .closeButton {
    position: absolute;
    right: 25px;
    top: 25px;
  }
  .systemIcon {
    position: absolute;
    left: 36px;
    top: 38px;
  }
  .systemTitle {
    position: absolute;
    top: 52px;
    left: 129px;
  }
  .systemSubtitle {
    position: absolute;
    top: 101px;
    left: 129px;
  }
  .subsystemCardContainer {
    margin-top: 170px;
    margin-left: 75px;
    max-height: 580px;
    max-width: 520px;
  }
  /* Fade out bottom of scrollable content */
  .subsystemCardContainer::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100px;
    background: linear-gradient(to bottom, transparent, white 100%);
    pointer-events: none; /* Allows interaction with the scrollable content */
    border-radius: 20px;
  }

  .subsystemCard {
    cursor: pointer;
  }

  .subsystemIcon {
    position: absolute;
    left: 16px;
    top: 20px;
  }

  .subsystemTitle {
    border-top-left-radius: 0px !important;
    position: absolute;
    left: 72px;
    top: 11px;
    font-weight: 400 !important;

    text-wrap: nowrap;
    /* Container dimensions and positioning */
    width: 350px; /* Adjust width as needed */
    height: auto;
    overflow: hidden; /* Hide overflow */
    text-overflow: inherit;
    /* Text properties */
    white-space: nowrap; /* Keep text in a single line */

    /* Masking to create fade effect */
    -webkit-mask-image: linear-gradient(to right, black 75%, transparent 100%);
    mask-image: linear-gradient(to right, black 75%, transparent 100%);
  }

  .subsystemSubtitle {
    border-bottom-left-radius: 0px !important;
    position: absolute;
    left: 72px;
    top: 41px;

    /* text-wrap: nowrap; */
    /* Container dimensions and positioning */
    width: 350px; /* Adjust width as needed */
    height: auto;
    /* overflow: hidden; Hide overflow */
    text-overflow: inherit;
    /* Text properties */
    /* white-space: nowrap; Keep text in a single line */

    /* Masking to create fade effect */
    /* -webkit-mask-image: linear-gradient(to right, black 75%, transparent 100%);
    mask-image: linear-gradient(to right, black 75%, transparent 100%); */
  }
</style>
